<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-paper-roll-outline">{{
              $t("dashboardCardSuperAdminPaperType")
            }}</main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <div>
              <data-table-search-toolbar
                :search.sync="search"
              ></data-table-search-toolbar>
              <v-data-table
                :loading-text="$t('lmPleaseWait')"
                class="#505050--text"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; border-top: none; background-color: white'
                    : 'border: none; background-color: white'
                "
                :headers="headers"
                :items="$store.state.storePaperType.paperType"
                :search="search"
                sort-by="paperType"
                :items-per-page="-1"
                must-sort
                :no-results-text="$t('dataGridSlotNoResults')"
                :no-data-text="$t('dataGridSlotNoData')"
                :footer-props="{
                  itemsPerPageText: $t('dataGridRowsPerPageText'),
                  itemsPerPageAllText: $t('dataGridRowsPerPageAllText'),
                }"
              >
                <template v-slot:item.paperType="{ item }">
                  <v-chip :color="getColor(item.default)">{{
                    item.paperType
                  }}</v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="d-flex flex-no-wrap">
                    <v-icon class="mr-3" @click="editItem(item)"
                      >mdi-pencil</v-icon
                    >
                    <v-icon @click="deleteItemSet(item.id)">mdi-delete</v-icon>
                  </div>
                </template>
              </v-data-table>
            </div>
            <!-- DELETE CONFIRM DIALOG -->
            <dialog-basic-yes-no
              :active="dialogDelete"
              @clickYes="deleteItem"
              @clickNo="dialogDelete = false"
              icon="mdi-comment-question-outline"
              :title="$t('msgQuestion')"
              >{{ $t("deleteDialogQuestion") }}</dialog-basic-yes-no
            >
          </v-flex>
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'settingsSubMenuModulePhotoOrder' })"
          ></simple-navigation-button>
          <!-- ADD / EDIT DIALOG -->
          <v-dialog
            v-model="dialog"
            max-width="500px"
            persistent
            transition="dialog-bottom-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn color="primary" v-on="on" dark fixed bottom right rounded>
                <v-icon medium class="mr-1">mdi-plus</v-icon>
                {{ $t("lmBtnAdd") }}
              </v-btn>
            </template>
            <v-form ref="form" v-model="valid">
              <v-card
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? ''
                    : 'border-bottom: 1px solid lightgray'
                "
              >
                <v-card-title
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: #505050'
                      : 'background-color: white; border-bottom: 1px solid lightgray'
                  "
                  :class="
                    getTheme() == 'dark' ? 'white--text' : '#505050--text'
                  "
                  class="title font-weight-regular"
                >
                  <v-icon
                    :class="
                      getTheme() == 'dark' ? 'white--text' : 'primary--text'
                    "
                    class="mr-3"
                    medium
                    >{{
                      this.editedIndex == -1 ? "mdi-plus" : "mdi-pencil"
                    }}</v-icon
                  >
                  {{ formTitle }}
                </v-card-title>
                <v-card-text class="py-0 pt-2">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field
                          dense
                          v-model="editedItem.paperType"
                          :label="
                            $t('settingsPaperTypeGridHeaderPaperTypeTitle')
                          "
                          :rules="[validateRequired(), validateMaxLength(50)]"
                          :counter="50"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          dense
                          v-model="editedItem.paperTypeFile"
                          :label="
                            $t('settingsPaperTypeGridHeaderPaperTypeFileTitle')
                          "
                          :rules="[validateRequired(), validateMaxLength(20)]"
                          :counter="20"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          dense
                          v-model="editedItem.price"
                          :label="$t('settingsPaperTypeGridHeaderPriceTitle')"
                          :rules="[
                            validateRequired(),
                            validateIsPercent(),
                            validateMaxLength(3),
                          ]"
                          :counter="3"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="editedItem.default"
                          :label="$t('settingsPaperTypeGridHeaderDefaultTitle')"
                        ></v-switch>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions
                  :class="
                    getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                  "
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                      : 'background-color: white; border-top: 1px solid lightgray;'
                  "
                >
                  <v-spacer></v-spacer>
                  <v-btn color="primary" class="my-1" text @click="close">{{
                    $t("addEditFormCancelButton")
                  }}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn @click="save" color="primary" dark>
                    <v-icon medium class="mr-1">mdi-content-save</v-icon>
                    {{ $t("addEditFormSaveButton") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
          <v-snackbar
            v-model="$store.state.storeSnackbar.snackbar.active"
            :color="$store.state.storeSnackbar.snackbar.color"
            :timeout="$store.state.storeSnackbar.snackbar.timeout"
            >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
          >
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import DialogBasicYesNo from "@/components/DialogBasicYesNo";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import DataTableSearchToolbar from "@/components/DataTableSearchToolbar";

export default {
  name: "settingsPaperType",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    DialogBasicYesNo,
    SimpleNavigationButton,
    DataTableSearchToolbar,
  },
  data() {
    return {
      valid: true,
      netBackImage: require("@/assets/netBack.png"),
      search: "",
      dialog: false,
      dialogDelete: false,
      dialogDeleteId: "",
      headers: [
        {
          text: this.$t("settingsPaperTypeGridHeaderPaperTypeTitle"),
          align: "center",
          value: "paperType",
          sortable: true,
        },
        {
          text: this.$t("settingsPaperTypeGridHeaderPaperTypeFileTitle"),
          align: "center",
          value: "paperTypeFile",
          sortable: true,
        },
        {
          text: this.$t("settingsPaperTypeGridHeaderPriceTitle"),
          align: "center",
          value: "price",
        },
        {
          text: "",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
      editedIndex: -1,
      editedItem: {
        id: "",
        paperType: "",
        paperTypeFile: "",
        price: 0,
        default: true,
        client: this.$store.state.storeClient.client.basicSettings.name,
      },
      defaultItem: {
        id: "",
        paperType: "",
        paperTypeFile: "",
        price: 0,
        default: true,
        client: this.$store.state.storeClient.client.basicSettings.name,
      },
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("addEditFormAddingTitle")
        : this.$t("addEditFormEditingTitle");
    },
  },
  methods: {
    getBooleanIcon(val) {
      return val ? "mdi-check-bold" : "mdi-close-circle-outline";
    },
    getColor(val) {
      if (val) return "success";
    },
    deleteItemSet(item) {
      this.dialogDelete = true;
      this.dialogDeleteId = item;
    },
    async deleteItem() {
      try {
        await this.$store.dispatch("removePaperType", this.dialogDeleteId);
        this.dialogDelete = false;
        this.dialogDeleteId = "";
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
      this.$store.commit({
        type: "showSnackbar",
        color: "success",
        message: this.$t("msgSuccessDelete"),
      });
    },
    editItem(item) {
      this.editedIndex =
        this.$store.state.storePaperType.paperType.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
    async save() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          try {
            await this.$store.dispatch("editPaperType", this.editedItem);
            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessEdit"),
            });
          } catch (error) {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: error,
            });
          }
        } else {
          try {
            await this.$store.dispatch("addPaperType", this.editedItem);
            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessAdd"),
            });
          } catch (error) {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: error,
            });
          }
        }
        this.close();
      }
    },
  },
  created() {
    this.$store.dispatch(
      "getPaperType",
      this.$store.state.storeClient.client.basicSettings.name
    );
  },
};
</script>